import React from 'react'

import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';
//import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader';
import { gsap } from "gsap";

import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer'
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass'
//import { SSAARenderPass } from 'three/examples/jsm/postprocessing/SSAARenderPass'

import { UnrealBloomPass } from 'three/examples/jsm/postprocessing/UnrealBloomPass'

import { modelsData } from '../../data/models.data';
import { colorsData } from '../../data/colors.data';
import { getBillboardsData as billboardsData, getSceneData as sceneData } from '../../helpers/strapi.helper';
import { texturesData } from '../../data/textures.data';

//import { ShaderPass } from 'three/examples/jsm/postprocessing/ShaderPass';
//import { FXAAShader } from 'three/examples/jsm/shaders/FXAAShader';

import { SAOPass } from 'three/examples/jsm/postprocessing/SAOPass';
//import { SSAOPass } from 'three/examples/jsm/postprocessing/SSAOPass';

//import { TAARenderPass } from 'three/examples/jsm/postprocessing/TAARenderPass';
//import Stats from 'three/examples/jsm/libs/stats.module';
//import { BrightnessContrastShader } from 'three/examples/jsm/shaders/BrightnessContrastShader';

//AR Elements
import { createPlaneMarker } from "../../helpers/createPlaneMaker";
import { ARButton } from "three/examples/jsm/webxr/ARButton"; 
import {IsBrowserARCompatible} from '../../helpers/IsBrowserARCompatible';
import { handleXRHitTest } from "../../helpers/handleXRHitTest";
import { GLTFExporter } from 'three/examples/jsm/exporters/GLTFExporter';
/*eslint-disable */

interface Scene {
  canvasRef: any
  sceneRef: any
  cameraRef: any
  rendererRef: any,
  controlsRef: any,
  fpControlsRef: any
  target: any
  animationRef: any
  modelRef: any
  modelInteriorRef: any,
  domeRef: any,
  bloompassRef: any,
  saopassRef: any,
  euler: any,
  statsRef: any,
  materialsUpdatesRef: any,
  lightConfigRef: any,
  animationsConfigRef: any,
  pendingMaterials: any,
  ambientLightRef: any,
  planeAR: any,
  planeARVisible: boolean,
  inARMode: boolean,
  inARModePreviously: boolean,
  defaultSceneAR: any,
  defaultAREnvironment: any,
  buttonAR: any,
  enableARGlobally: boolean,
  renderScale: number
  targetFramerate: number
  averageRenderTime: number
  frameCount: number
}

interface Props {
  openScene: boolean,
  turnOffLights: boolean,
  handleCloseAllMenus: () => void,
  handleCloseDrag: () => void,
  counter: number,
  currentCompleteCar: string,
  currentColorSelected: string,
  isLocale: boolean,
  handleIsLocale: () => void,
  handleGetLoadPercentage: (payload: number) => void,
  showInterior: boolean,
  currentSeatSelected: string,
  handleLoadInterior: (payload: number) => void,
  handleSelectBillboard: (payload: string) => void,
  showBullets: boolean,
  showBulletsInterior: boolean,
  currentSceneSelected: any,
  showVideo: boolean,
  handleShowVideo: (payload: boolean) => void
  handleShowVideoText: (payload: boolean) => void
  handleOpenDrag: () => void
  handleIsPlayingAnimation: (payload: boolean) => void,
  isPlayingAnimation: boolean,
  handleOpenScene: () => void,
  showLigths: boolean
  showInteriorLights: boolean
  handleShowLigths: (payload: boolean) => void
  handleShowInteriorLights: (payload: boolean) => void
  isTouchScreen: boolean
  enableAR: boolean
  download3DModel: boolean
}

interface State {
    animationAction: any,
    wheelAnimation: any,
    doorAnimation: any,
    moveInAnimation: any,
    currentDomeSelected: any
    videoAnimation: any,
    materialToCreate: any,
    materialsLoadRef: any,
    targetExterior: any,
    fovExterior: any,
    fovInterior: any,
    //nextTouchFov: any,
    //touchDistanceFov: any,
    //touchGesture: boolean
}

declare const window: any;

class Scene extends React.Component<Props,State>{
  constructor(props: Props){
    super(props);
    this.state = {
      animationAction: '',
      wheelAnimation: '',
      doorAnimation: '',
      moveInAnimation: '',
      currentDomeSelected: 'Estudio',
      videoAnimation: '',
      materialToCreate: '',
      materialsLoadRef: 0,
      targetExterior: new THREE.Vector3(),
      fovExterior: 50,
      fovInterior: 80,
      //nextTouchFov: 0,
      //touchDistanceFov: 0,
      //touchGesture: false,
    }

    this.canvasRef = React.createRef()
    this.sceneRef = React.createRef()
    this.cameraRef = React.createRef()
    this.rendererRef = React.createRef()
    this.controlsRef = React.createRef()
    this.fpControlsRef = React.createRef()
    this.animationRef = React.createRef()
    this.modelRef = null
    this.modelInteriorRef = React.createRef()
    this.domeRef = null
    this.bloompassRef = React.createRef()
    this.saopassRef = React.createRef()
    this.euler = new THREE.Euler(0, 0, 0, 'YXZ')
    this.statsRef = React.createRef(),
    this.materialsUpdatesRef = React.createRef()
    this.lightConfigRef = React.createRef()
    this.animationsConfigRef = React.createRef()
    this.pendingMaterials = React.createRef()
    this.ambientLightRef = React.createRef()
    this.planeAR = React.createRef()
    this.planeARVisible = false
    this.inARMode = false
    this.inARModePreviously = false
    this.defaultSceneAR = null
    this.defaultAREnvironment = React.createRef()
    this.buttonAR = null
    this.enableARGlobally = false //allow AR feature, should be false for test and production for now
    this.renderScale = 1
    this.targetFramerate = 30
    this.averageRenderTime = 0
    this.frameCount = 60
  }

  componentDidMount(): void {
    this.handleCreateScene()
    window.addEventListener('resize', this.handleResize)
  }

  componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {
    if(prevProps.openScene !== this.props.openScene){
      this.handleMoveCameraStart()
    }
    if(prevProps.turnOffLights !== this.props.turnOffLights && this.props.showInterior === prevProps.showInterior){
      this.handleTurnOffLigths()
    }
    if(prevProps.currentCompleteCar !== this.props.currentCompleteCar && this.props.currentCompleteCar !== ''){
      this.handleCreateMaterials()
    }
    if(prevProps.currentColorSelected !== this.props.currentColorSelected){
      this.handleChangeColor()
    }
    if(prevProps.showInterior !== this.props.showInterior && this.props.showInterior){
      this.handleMoveCameraToInterior()
    }
    if(prevProps.showInterior !== this.props.showInterior && !this.props.showInterior){
      this.handleMoveCameraToExterior()
    }
    if(prevProps.currentSeatSelected !== this.props.currentSeatSelected){
      this.handleChangeSeat()
    }
    if(prevProps.showBullets !== this.props.showBullets){
      this.handleShowBullets()
    }
    if(prevProps.showBulletsInterior !== this.props.showBulletsInterior){
      this.handleShowBulletsInterior()
    }
    if(prevProps.currentSceneSelected !== this.props.currentSceneSelected){
      this.handleChangeScene()
    }
    if(prevProps.showVideo !== this.props.showVideo){
      this.handlePlayVideo()
    }
    if(prevProps.enableAR !== this.props.enableAR && this.props.enableAR === true){
      this.enableAR()
    }
    if(prevProps.download3DModel !== this.props.download3DModel && this.props.download3DModel === true){
      this.exportGLTFModel()
    }
  }

  componentWillUnmount(): void {
    this.canvasRef = null
    if(this.buttonAR !== null){
      document.body.removeChild(this.buttonAR);
    }
    window.removeEventListener('resize',this.handleResize)
    document.removeEventListener('visibilitychange', this.visibilityChange);
    document.removeEventListener('wheel', this.handleMouseWheel)
    this.disposeScene()
    this.rendererRef.dispose();
  }

  // Function to dispose of materials
  disposeMaterial = (material: any) => {
    material.dispose();
    if (material.map) material.map.dispose(); // Dispose textures
    if (material.lightMap) material.lightMap.dispose();
    if (material.bumpMap) material.bumpMap.dispose();
    if (material.normalMap) material.normalMap.dispose();
    if (material.specularMap) material.specularMap.dispose();
    if (material.envMap) material.envMap.dispose();
    if (material.alphaMap) material.alphaMap.dispose();
    if (material.aoMap) material.aoMap.dispose();
    if (material.displacementMap) material.displacementMap.dispose();
    if (material.emissiveMap) material.emissiveMap.dispose();
    if (material.gradientMap) material.gradientMap.dispose();
    if (material.metalnessMap) material.metalnessMap.dispose();
    if (material.roughnessMap) material.roughnessMap.dispose();
  }

// Function to traverse the scene and dispose of all objects
  disposeScene = () => {
    this.sceneRef.traverse((object: any) => {
      if (object instanceof THREE.Mesh) {
          object.geometry.dispose(); // Dispose of geometry
          if (object.material instanceof THREE.Material) {
              this.disposeMaterial(object.material); // Dispose of a single material
          } else if (Array.isArray(object.material)) {
              object.material.forEach(material => this.disposeMaterial(material));
          }
      }
    })
    this.sceneRef = null as any;
  }

  handleCreateScene = () => {
    this.pendingMaterials = 0
    window.mixer = ''

    this.animationsConfigRef = {activeAnimation: '', startingCamera: '', config: {}}

    const mountRef = this.canvasRef
    const scene = new THREE.Scene()
    //scene.background = new THREE.Color(0xD8D8CF)
    this.sceneRef = scene

    //Camera
    const camera = new THREE.PerspectiveCamera(this.state.fovExterior, mountRef.current.clientWidth / mountRef.current.clientHeight, 0.01, 50)
    camera.position.set(0, 6, 12)
    this.cameraRef = camera

    scene.add(camera)

    mountRef.current.addEventListener('click', (event: any) => {
      var mouse = new THREE.Vector2();
      mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
      mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;

      var raycaster = new THREE.Raycaster();

      raycaster.setFromCamera(mouse, this.cameraRef);

      var intersects = raycaster.intersectObjects(scene.children, true);

      if (intersects.length > 0 && (this.props.showBullets || this.props.showBulletsInterior)) {

        var firstIntersectedMesh = intersects[0].object;
        if(firstIntersectedMesh.name.includes('billboard')){
          //document.body.style.cursor = 'pointer'
          this.props.handleSelectBillboard(firstIntersectedMesh.name.replace(' billboard',''))
        }
        //else {
        //  document.body.style.cursor = 'default'
        //}
      }
    }, false)
    mountRef.current.addEventListener('touchstart', (event: any) => {
      this.props.handleCloseAllMenus()
    }, false)
    mountRef.current.addEventListener('mousedown', (event: any) => {
      this.props.handleCloseAllMenus()
    }, false)

    document.addEventListener('visibilitychange', this.visibilityChange);

    var scenesData : any = {};
    if (this.props.currentSceneSelected && Object.keys(this.props.currentSceneSelected).length > 0) {
      this.lightConfigRef = this.props.currentSceneSelected;
      this.defaultSceneAR = this.props.currentSceneSelected;
    } else {
      scenesData = sceneData(this.props.currentCompleteCar);
      let defaultSceneKey = Object.keys(scenesData).find(key => scenesData[key].default === true);
      if (!defaultSceneKey && Object.keys(scenesData).length > 0) {
        defaultSceneKey = Object.keys(scenesData)[0];
      }
      if (defaultSceneKey) {
        this.lightConfigRef = scenesData[defaultSceneKey];
        this.defaultSceneAR = scenesData[defaultSceneKey];
      } else {
        var baseScenesData : any = sceneData();
        Object.keys(baseScenesData).map((scene: any) => {
          if(baseScenesData[scene].default){
            this.defaultSceneAR = baseScenesData[scene];
            this.lightConfigRef = baseScenesData[scene];
          }
        });
      }
    }

    // Env
    const loader = new THREE.CubeTextureLoader()
    loader.setPath(this.lightConfigRef.hdr).load(['px.png','nx.png','py.png','ny.png','pz.png','nz.png'],(texture: any) => {
      
      texture.flipY = false
      scene.environment = texture
      this.defaultAREnvironment = texture
      //scene.background = texture
    })

    // Ambient Light
    const ambLigth = new THREE.AmbientLight(0x000000, 1)
    scene.add(ambLigth)
    this.ambientLightRef = ambLigth
    if("ambientLight" in this.lightConfigRef){
      this.ambientLightRef.color = new THREE.Color(this.lightConfigRef.ambientLight.color)
      this.ambientLightRef.intensity = this.lightConfigRef.ambientLight.intensity
    }
    
    //Renderer
    const renderer: any = new THREE.WebGLRenderer({
      canvas: mountRef.current,
      antialias: false,
      precision: 'lowp',
      powerPreference: 'low-power',
      //preserveDrawingBuffer: true,
      logarithmicDepthBuffer: true,
    })
    
    renderer.setSize(mountRef.current.clientWidth * this.renderScale, mountRef.current.clientHeight * this.renderScale)
    renderer.setPixelRatio(window.devicePixelRatio)
    renderer.toneMapping = THREE.LinearToneMapping;
    renderer.tonemappingExposure = 1
    renderer.outputColorSpace = THREE.LinearSRGBColorSpace
    renderer.localClippingEnabled = true
    renderer.shadowMap.enabled = false

    /******AR SETUP****/
    IsBrowserARCompatible().then((value) => {
      if (value === true && this.enableARGlobally === true) {
        renderer.xr.enabled = true;

        this.buttonAR = ARButton.createButton(renderer, { requiredFeatures: ["hit-test"] })//id="ARButton"
        this.buttonAR.style.display = 'none'//not working :/
        this.buttonAR.style.bottom = '-2000px'
        document.body.appendChild(this.buttonAR);

        const planeMarker = createPlaneMarker();
        this.planeAR = planeMarker
        this.planeAR.visible = this.planeARVisible;
        scene.add(planeMarker);

        const controller = renderer.xr.getController(0);
        scene.add(controller);
        controller.addEventListener("select", this.handleARPlaneSelection);
        renderer.setAnimationLoop(this.onXRFrame);
      }
    });
    /**END AR SETUP**/

    const renderTarget = new THREE.WebGLRenderTarget(
      mountRef.current.clientWidth,
      mountRef.current.clientHeight,
      {
        minFilter: THREE.NearestFilter,
        magFilter: THREE.NearestFilter,
        format: THREE.RGBAFormat,
        //type: THREE.HalfFloatType,
        //colorSpace: THREE.SRGBColorSpace
      }
    )
    //renderTarget.samples = 2
    this.rendererRef = renderer
    renderer.render(scene, camera)

    const effectComposer = new EffectComposer(renderer)//const effectComposer = new EffectComposer(renderer, renderTarget)
    effectComposer.setPixelRatio(Math.min(window.devicePixelRatio,2))
    effectComposer.setSize(mountRef.current.clientWidth  * this.renderScale, mountRef.current.clientHeight  * this.renderScale)

    const renderPass = new RenderPass(scene, camera)
    effectComposer.addPass(renderPass)

    /*const taaRenderPass = new TAARenderPass(scene, camera, 0x000000, 1)
    taaRenderPass.unbiased = false;
    taaRenderPass.sampleLevel = 2;
    effectComposer.addPass(taaRenderPass)/
    /*
    var fxaaPass = new ShaderPass(FXAAShader);
    var pixelRatio = renderer.getPixelRatio();
    fxaaPass.material.uniforms['resolution'].value.set( 2 / (window.innerWidth * pixelRatio) , 2 / (window.innerHeight * pixelRatio) );
    effectComposer.addPass(fxaaPass)
    */
    const saoPass = new SAOPass(scene, camera, true, true);
    //saoPass.resolution.set(8, 8)
    saoPass.params.output = SAOPass.OUTPUT.Default // SAOPass.OUTPUT.SAO  | SAOPass.OUTPUT.Default
    saoPass.params.saoBias = 1; // [-1 1]
    saoPass.params.saoIntensity = 0.005; //[0 1]
    saoPass.params.saoScale = 2; //[0 10]
    saoPass.params.saoKernelRadius = 40; //[0 100]
    saoPass.params.saoMinResolution = 0; //[0 1]
    saoPass.params.saoBlur = true;
    saoPass.params.saoBlurRadius = 8;
    saoPass.params.saoBlurStdDev = 8;
    saoPass.params.saoBlurDepthCutoff = 0.01;
    saoPass.enabled = false
    this.saopassRef = saoPass
    //effectComposer.addPass(saoPass);
    /*
    const ssaoPass = new SSAOPass(scene, camera);
    ssaoPass.output = 0 //Default=0, SSAO=1, Blur=2, Beauty=3, Depth=4, Normal=5
    ssaoPass.kernelRadius = 3 //[0 32]
    ssaoPass.minDistance = 0.1 //[0 0.02]
    ssaoPass.maxDistance = 0.3 //[0 0.3]
    ssaoPass.renderToScreen = false
    effectComposer.addPass(ssaoPass);
    */
   /*
    var brightnessContrastShader = new ShaderPass(BrightnessContrastShader);
    brightnessContrastShader.uniforms.brightness.value = 0.01 //[0 1]
    brightnessContrastShader.uniforms.contrast.value = 0.033 //[0 1]
    effectComposer.addPass(brightnessContrastShader)*/

    const unrealBloomPass = new UnrealBloomPass(new THREE.Vector2(mountRef.current.clientWidth * renderer.getPixelRatio(), mountRef.current.clientHeight * renderer.getPixelRatio()), 0, 0, 0)
    unrealBloomPass.threshold = 1
    unrealBloomPass.strength = 0.4
    unrealBloomPass.radius = 0.2
    unrealBloomPass.enabled = false
    this.bloompassRef = unrealBloomPass
    effectComposer.addPass(unrealBloomPass)

    window.effectComposer = effectComposer
        
    //Controls
    const controls = new OrbitControls(camera, renderer.domElement)
    controls.target = new THREE.Vector3(0,1,0)
    controls.enableDamping = true
    controls.enablePan = false
    controls.minDistance = 3
    controls.maxDistance = 9
    controls.minPolarAngle = 0
    controls.maxPolarAngle = 90 * (Math.PI / 180)
    controls.enabled = false
    this.controlsRef = controls

    const clock = new THREE.Clock()
    window.clock = clock
    /*
    const onTouchMove = (event: TouchEvent): void => {
      if (event.touches.length === 2) {
        // Calcula la distancia actual entre los dos puntos táctiles
        
        const touch1 = event.touches[0];
        const touch2 = event.touches[1];
        const distance = Math.sqrt(Math.pow(touch2.pageX - touch1.pageX, 2) + Math.pow(touch2.pageY - touch1.pageY, 2));

        if (this.state.touchDistanceFov !== 0) {
          const deltaDistance = distance - this.state.touchDistanceFov;
          this.setState({
            nextTouchFov: this.cameraRef.fov - 0.5*deltaDistance
          })
        }
        this.setState({
          touchGesture: true,
          touchDistanceFov: distance
        })
      }else{
        this.setState({
          touchGesture: false
        })
      }
    };
    document.addEventListener('touchmove', onTouchMove);
    */

    this.handleAnimate()
  }

  visibilityChange = () => {
    if(document.hidden) window.clock.running = false
      else window.clock.start()
  }

  handleLoadDome = () => {
      const gltfLoader = new GLTFLoader()
      const dracoLoader = new DRACOLoader()
      dracoLoader.setDecoderPath('draco/')
      gltfLoader.setDRACOLoader(dracoLoader)

      const texture = new THREE.TextureLoader().load(this.lightConfigRef.map)

      gltfLoader.load('models/dome.glb', (gltf: any) => {
        const model = gltf.scene
        model.scale.set(1,1,1)

        this.domeRef = model

        var colorData: any = colorsData()
        var color = colorData[this.props.currentCompleteCar][this.props.currentColorSelected].setUp
        const colorToAssing = new THREE.Color(color.color)
        var domeColor = "domeColor" in color ? new THREE.Color(color.domeColor) : colorToAssing

        const material = model.getObjectByName('Skydome')
        if(material){
          material.material = new THREE.MeshBasicMaterial({
            name: 'M_BodyPaint_Dome',
            color: domeColor,
            map: texture,
          })

        }
        model.name = 'dome'
        this.sceneRef.add(model)

        this.rendererRef.renderLists.dispose()
        this.props.handleOpenScene()
      })
  }

  enableAR = () => {
    this.sceneRef.environment = this.defaultAREnvironment
    const arbutton = document.getElementById("ARButton");
    if(arbutton)
        arbutton.click()
  }

  exportGLTFModel = () => {
    const exporter = new GLTFExporter();
    exporter.parse(
      this.modelRef,
      (gltf: object) => {
        const output = JSON.stringify(gltf, null, 2);
        const blob = new Blob([output], { type: 'text/plain' });
        const link = document.createElement('a');
        link.style.display = 'none';
        document.body.appendChild(link); // Append link to the body
        link.href = URL.createObjectURL(blob);
        link.download = this.props.currentCompleteCar + '_' + this.props.currentColorSelected + '.gltf';
        link.click();
        document.body.removeChild(link);
      },
      (error: any) => {
        console.log("error exporting model")
      }
    );
  }

  handleARPlaneSelection = () => {    
    if (this.planeAR.visible) {
      this.modelRef.position.setFromMatrixPosition(this.planeAR.matrix);
      //model.rotation.y = (Math.PI * 2); TODO
      this.modelRef.visible = true;
      this.planeARVisible = false;
      this.planeAR.visible = this.planeARVisible;
    }
  }

  onXRFrame = (timestamp: number, frame?: XRFrame) => {
    if(this.canvasRef === null){
      this.rendererRef.setAnimationLoop(null);
      return
    }

    this.inARMode = this.rendererRef.xr.isPresenting
      
      if(this.inARModePreviously !== this.inARMode){
        if(this.inARMode){//Enters ARMode
          if(this.domeRef !== null)
            this.domeRef.visible = false
          if(this.modelRef !== null)
            this.modelRef.visible = false
          this.planeARVisible = true
          this.handleChangeScene()
        }else{//Exits ARMode
          if(this.domeRef !== null)
            this.domeRef.visible = true
          if(this.modelRef !== null){
            this.modelRef.position.set(0,0,0);
            this.modelRef.visible = true
          }
          this.planeARVisible = false
          this.planeAR.visible = false
          this.handleChangeScene()
          requestAnimationFrame(this.handleAnimate)
        }
      }

      if (this.rendererRef.xr.isPresenting) {
        if (frame) {
          handleXRHitTest(this.rendererRef, frame, (hitPoseTransformed: Float32Array) => {
            if (hitPoseTransformed) {
              this.planeAR.visible = this.planeARVisible;
              this.planeAR.matrix.fromArray(hitPoseTransformed);
            }
          }, () => {
            this.planeAR.visible = false;
          })
        }
        this.rendererRef.render(this.sceneRef, this.cameraRef)
      }
      this.inARModePreviously = this.inARMode
  }

  handleAnimate = () => {
    if(!this.canvasRef)
      return
    if(this.inARMode === true)
      return

    requestAnimationFrame(this.handleAnimate)

    const deltaTime = window.clock.getDelta()
    if(window.mixer !== ''){
      window.mixer.update(deltaTime)
    }

    if (this.animationsConfigRef.activeAnimation){
      this.handleAllAnimations()
    }

    if(window.billboard && this.props.showBullets){
      window.billboard.children.forEach((object: any) => {
        object.lookAt(this.cameraRef.position)
      })
    }
    if(window.billboardInterior && this.props.showBulletsInterior){
      window.billboardInterior.children.forEach((object: any) => {
        object.lookAt(this.cameraRef.position)
      })
    }
/*
    if (this.state.nextTouchFov !== 0 && this.props.showInterior) {
      var fov = this.state.nextTouchFov
      if (fov > 70){
        fov = 70
      }
      if (fov < 30){
        fov = 30
      }
      this.cameraRef.fov = fov
      this.cameraRef.updateProjectionMatrix();
      this.setState({
        nextTouchFov: 0
      })
    }*/

    this.averageRenderTime = this.averageRenderTime + deltaTime
    this.frameCount = this.frameCount - 1
    if(this.frameCount < 0){
      this.frameCount = 60
      const avgFrameRate = this.frameCount / this.averageRenderTime
      this.averageRenderTime = 0
      const scaleChage = avgFrameRate > this.targetFramerate ? 0.1 : -0.1
      this.renderScale = this.renderScale + scaleChage
      if(this.renderScale > 1)
        this.renderScale = 1
      if(this.renderScale < 0.5)
        this.renderScale = 0.5
      
      const size = this.rendererRef.getSize(new THREE.Vector2());
      if(size.x !== window.innerWidth * this.renderScale)
        this.rendererRef.setSize(window.innerWidth * this.renderScale, window.innerHeight * this.renderScale)
    }
    //if (!this.state.touchGesture)
    this.controlsRef.update()
    
    //this.statsRef.update();
    window.effectComposer.render()
    //this.rendererRef.render(this.sceneRef, this.cameraRef)
  }

  handleResize = () => {
    this.cameraRef.aspect = window.innerWidth / window.innerHeight
    this.cameraRef.updateProjectionMatrix()
    this.rendererRef.setSize(window.innerWidth, window.innerHeight)
  }

  handleTurnOffLigths = () => {
    var transitionDuration = 1
    if(!this.lightConfigRef){
      return
    }
    
    if (this.props.turnOffLights) {
      //start
      var toneMapping = this.props.showInterior ? this.lightConfigRef.lightsOff.interiorToneMappingExposure : this.lightConfigRef.lightsOff.exteriorToneMappingExposure;
      Object.keys(this.materialsUpdatesRef.lightsOffTransition).map((materialName: any) => {
        
        var transition = this.materialsUpdatesRef.lightsOffTransition[materialName]

        if (transition.updateAt === 'start') {
          var material = transition.material
          material.emissiveIntensity = transition.emissiveIntensity
          material.envMapIntensity = transition.envMapIntensity
          material.opacity = transition.opacity
          if ("color" in transition)
            material.color = new THREE.Color(transition.color)
          if ("emissive" in transition)
            material.emissive = new THREE.Color(transition.emissive)
        }
      })
      this.bloompassRef.enabled = true

      gsap.to(this.rendererRef, {
        toneMappingExposure: toneMapping,
        duration: transitionDuration,
        ease: "linear",
        onComplete: () => {
          Object.keys(this.materialsUpdatesRef.lightsOffTransition).map((materialName: any) => {
            var transition = this.materialsUpdatesRef.lightsOffTransition[materialName]
    
            if (transition.updateAt === 'end') {
              var material = transition.material
              material.emissiveIntensity = transition.emissiveIntensity
              material.envMapIntensity = transition.envMapIntensity
              material.opacity = transition.opacity
              if ("color" in transition)
                material.color = new THREE.Color(transition.color)
              if ("emissive" in transition)
                material.emissive = new THREE.Color(transition.emissive)
            }
          })
          
          this.rendererRef.renderLists.dispose()
        }
      })

      Object.keys(this.materialsUpdatesRef.lightsOffTransition).map((materialName: any) => {
        var transition = this.materialsUpdatesRef.lightsOffTransition[materialName]
        if (transition.updateAt === 'transition') {
          gsap.to(transition.material, {
            emissiveIntensity: transition.emissiveIntensity,
            envMapIntensity: transition.envMapIntensity,
            opacity: transition.opacity,
            duration: transitionDuration
          })
          if("color" in transition){
            const color = new THREE.Color(transition.color)
            gsap.to(transition.material.color, {
              r: color.r,
              g: color.g,
              b: color.b,
              duration: transitionDuration
            })
          }
          if("emissive" in transition){
            const color = new THREE.Color(transition.emissive)
            gsap.to(transition.material.emissive, {
              r: color.r,
              g: color.g,
              b: color.b,
              duration: transitionDuration
            })
          }
        }
      })

      gsap.to(this.bloompassRef, {
        strength: this.props.showInterior ? this.lightConfigRef.lightsOff.interiorBloom.strength : this.lightConfigRef.lightsOff.exteriorBloom.strength,//this.props.showInterior ? 0.2 : 1.5,
        radius: this.props.showInterior ? this.lightConfigRef.lightsOff.interiorBloom.radius : this.lightConfigRef.lightsOff.exteriorBloom.radius,//this.props.showInterior ? 0.6 : 0.6,
        threshold: this.props.showInterior ? this.lightConfigRef.lightsOff.interiorBloom.threshold : this.lightConfigRef.lightsOff.exteriorBloom.threshold,//this.props.showInterior ? 0.2 : 0.4,
        duration: transitionDuration,
        ease: 'linear',
      })
      this.rendererRef.renderLists.dispose()

    } else {
      var toneMapping = this.props.showInterior ? this.lightConfigRef.lightsOn.interiorToneMappingExposure : this.lightConfigRef.lightsOn.exteriorToneMappingExposure;
      Object.keys(this.materialsUpdatesRef.lightsOnTransition).map((materialName: any) => {
        var transition = this.materialsUpdatesRef.lightsOnTransition[materialName]

        if (transition.updateAt === 'start') {
          var material = transition.material
          material.emissiveIntensity = transition.emissiveIntensity
          material.envMapIntensity = transition.envMapIntensity
          material.opacity = transition.opacity
          if ("color" in transition)
            material.color = new THREE.Color(transition.color)
          if ("emissive" in transition)
            material.emissive = new THREE.Color(transition.emissive)
        }
      })

      gsap.to(this.bloompassRef, {
        strength: this.props.showInterior ? this.lightConfigRef.lightsOn.interiorBloom.strength : this.lightConfigRef.lightsOn.exteriorBloom.strength,//0
        radius: this.props.showInterior ? this.lightConfigRef.lightsOn.interiorBloom.radius : this.lightConfigRef.lightsOn.exteriorBloom.radius,//0
        threshold: this.props.showInterior ? this.lightConfigRef.lightsOn.interiorBloom.threshold : this.lightConfigRef.lightsOn.exteriorBloom.threshold,//0
        duration: transitionDuration,
        ease: 'linear',
        onComplete: () => {
          gsap.to(this.rendererRef, {
            toneMappingExposure: toneMapping,
            duration: transitionDuration,
            ease: "power2.inOut",
            onComplete: () => {
              Object.keys(this.materialsUpdatesRef.lightsOnTransition).map((materialName: any) => {
                var transition = this.materialsUpdatesRef.lightsOnTransition[materialName]
        
                if (transition.updateAt === 'end') {
                  var material = transition.material
                  material.emissiveIntensity = transition.emissiveIntensity
                  material.envMapIntensity = transition.envMapIntensity
                  material.opacity = transition.opacity
                  if ("color" in transition)
                    material.color = new THREE.Color(transition.color)
                  if ("emissive" in transition)
                    material.emissive = new THREE.Color(transition.emissive)
                }
              })
              this.bloompassRef.enabled = false
              this.rendererRef.renderLists.dispose()
            }
          })

        }
        
      })
      Object.keys(this.materialsUpdatesRef.lightsOnTransition).map((materialName: any) => {
        var transition = this.materialsUpdatesRef.lightsOnTransition[materialName]

        if (transition.updateAt === 'transition') {
          gsap.to(transition.material, {
            emissiveIntensity: transition.emissiveIntensity,
            envMapIntensity: transition.envMapIntensity,
            opacity: transition.opacity,
            duration: transitionDuration
          })
          if("color" in transition){
            const color = new THREE.Color(transition.color)
            gsap.to(transition.material.color, {
              r: color.r,
              g: color.g,
              b: color.b,
              duration: transitionDuration
            })
          }
          if("emissive" in transition){
            const color = new THREE.Color(transition.emissive)
            gsap.to(transition.material.emissive, {
              r: color.r,
              g: color.g,
              b: color.b,
              duration: transitionDuration
            })
          }
        }
      })
      this.rendererRef.renderLists.dispose()

    }
  }

  handleCreateMaterials = () => {
    console.log("threejs v"+THREE.REVISION);
    const textureLoader = new THREE.TextureLoader();
    var textures: any = texturesData()
    var textureObject = textures[this.props.currentCompleteCar].materialData()[this.props.currentCompleteCar]
    var MaterialsToCreate: any = {}
    
    var MaterialsUpdates: any = {}
    var MaterialsUpdatesLightOn: any = {}
    var MaterialsUpdatesLightOff: any = {}
    const SupporteMaps: readonly string[] = ["sharedMap","alphaMap","aoMap","emissiveMap","envMap","lightMap","map","metalnessMap","normalMap","roughnessMap"];

    var nTexturesToLoad = 0
    
    Object.keys(textureObject).map((material: any) => {

      if (!MaterialsToCreate.hasOwnProperty(material) && textureObject[material].enable === true) {
        //CREATE THE RIGHT MATERIAL
        if (textureObject[material].type === 'physical') {
          MaterialsToCreate[material] = new THREE.MeshPhysicalMaterial({
            name: "name" in textureObject[material] ? textureObject[material].name : "",
            color: textureObject[material].color,
            clearcoat: textureObject[material].clearcoat,
            clearcoatRoughness: textureObject[material].clearcoatRoughness,
            depthTest: textureObject[material].depthTest,
            depthWrite: textureObject[material].depthWrite,
            transparent: textureObject[material].transparent,
            opacity: textureObject[material].opacity,
            side: textureObject[material].side,
            reflectivity: textureObject[material].reflectivity,
            thickness: textureObject[material].thickness,
            transmission: textureObject[material].transmission,

            aoMapIntensity: "aoMapIntensity" in textureObject[material] ? textureObject[material].aoMapIntensity : 1,
            emissive: "emissive" in textureObject[material]  ? textureObject[material].emissive : 0x000000,
            emissiveIntensity: "emissiveIntensity" in textureObject[material] ? textureObject[material].emissiveIntensity : 1,
            envMapIntensity: "envMapIntensity" in textureObject[material] ? textureObject[material].envMapIntensity : 1,
            lightMapIntensity: "lightMapIntensity" in textureObject[material] ? textureObject[material].lightMapIntensity : 1,
            metalness: "metalness" in textureObject[material] ? textureObject[material].metalness : 0,
            normalScale: "normalScale" in textureObject[material] ? new THREE.Vector2(textureObject[material].normalScale.x,textureObject[material].normalScale.y) : new THREE.Vector2(1,-1),
            roughness: "roughness" in textureObject[material] ? textureObject[material].roughness : 1,
          })
        }
        if (textureObject[material].type === 'standard') {
          MaterialsToCreate[material] = new THREE.MeshStandardMaterial({
            color: textureObject[material].color,
            transparent: textureObject[material].transparent,
            opacity: textureObject[material].opacity,
            depthTest: textureObject[material].depthTest,
            depthWrite: textureObject[material].depthWrite,

            aoMapIntensity: "aoMapIntensity" in textureObject[material] ? textureObject[material].aoMapIntensity : 1,
            emissive: "emissive" in textureObject[material]  ? textureObject[material].emissive : 0x000000,
            emissiveIntensity: "emissiveIntensity" in textureObject[material] ? textureObject[material].emissiveIntensity : 1,
            envMapIntensity: "envMapIntensity" in textureObject[material] ? textureObject[material].envMapIntensity : 1,
            lightMapIntensity: "lightMapIntensity" in textureObject[material] ? textureObject[material].lightMapIntensity : 1,
            metalness: "metalness" in textureObject[material] ? textureObject[material].metalness : 0,
            normalScale: "normalScale" in textureObject[material] ? textureObject[material].normalScale : new THREE.Vector2(1,-1),
            roughness: "roughness" in textureObject[material] ? textureObject[material].roughness : 1,
          })
        }
        if (textureObject[material].type === 'basic') {
          MaterialsToCreate[material] = new THREE.MeshBasicMaterial({
            color: textureObject[material].color,
            transparent: textureObject[material].transparent,
            opacity: textureObject[material].opacity,
            depthTest: textureObject[material].depthTest,
            depthWrite: textureObject[material].depthWrite,
            reflectivity: "reflectivity" in textureObject[material] ? textureObject[material].reflectivity : 0.5,
            aoMapIntensity: "aoMapIntensity" in textureObject[material] ? textureObject[material].aoMapIntensity : 1,
            lightMapIntensity: "lightMapIntensity" in textureObject[material] ? textureObject[material].lightMapIntensity : 1,
          })
        }

        //LOAD ALL TEXTURES
        
        Object.keys(SupporteMaps).map((index: any) => {
          var currentMap = SupporteMaps[index]
          if (currentMap in textureObject[material] && textureObject[material][currentMap].texture !== "") {
            nTexturesToLoad++, this.pendingMaterials = nTexturesToLoad
            //console.log(nTexturesToLoad)
            if (textureObject[material][currentMap].texture === "sharedMap") {

              textureLoader.load(textureObject[material].sharedMap.texture, (texture: any) => {
                texture.flipY = textureObject[material].sharedMap.flipY
                texture.channel = textureObject[material].sharedMap.channel
                texture.generateMipmaps = textureObject[material].sharedMap.generateMipmaps

                if ("repeat" in textureObject[material].sharedMap && textureObject[material].sharedMap.repeat.x !== 0 && textureObject[material].sharedMap.repeat.y !== 0) {
                  texture.repeat = new THREE.Vector2(textureObject[material].sharedMap.repeat.x , textureObject[material].sharedMap.repeat.y)
                  texture.wrapS = THREE.RepeatWrapping
                  texture.wrapT = THREE.RepeatWrapping
                }
                texture.minFilter = textureObject[material].sharedMap.minFilter
                texture.magFilter = textureObject[material].sharedMap.magFilter
                texture.anisotropy = textureObject[material].sharedMap.anisotropy < 1 ? this.rendererRef.capabilities.getMaxAnisotropy() : textureObject[material].sharedMap.anisotropy
                MaterialsToCreate[material][currentMap] = texture
                
                nTexturesToLoad--, this.pendingMaterials = nTexturesToLoad
                //console.log(nTexturesToLoad)
              })
            } else {

              textureLoader.load(textureObject[material][currentMap].texture, (texture: any) => {
                texture.flipY = textureObject[material][currentMap].flipY
                texture.channel = textureObject[material][currentMap].channel
                texture.generateMipmaps = textureObject[material][currentMap].generateMipmaps

                if ("repeat" in textureObject[material][currentMap] && textureObject[material][currentMap].repeat.x !== 0 && textureObject[material][currentMap].repeat.y !== 0) {
                  texture.repeat = new THREE.Vector2(textureObject[material][currentMap].repeat.x , textureObject[material][currentMap].repeat.y)
                  texture.wrapS = THREE.RepeatWrapping
                  texture.wrapT = THREE.RepeatWrapping
                }
                texture.minFilter = textureObject[material][currentMap].minFilter
                texture.magFilter = textureObject[material][currentMap].magFilter
                texture.anisotropy = textureObject[material][currentMap].anisotropy < 1 ? this.rendererRef.capabilities.getMaxAnisotropy() : textureObject[material][currentMap].anisotropy
                if(currentMap !== "sharedMap"){
                  MaterialsToCreate[material][currentMap] = texture
                }

                nTexturesToLoad--, this.pendingMaterials = nTexturesToLoad
                //console.log(nTexturesToLoad)
              })
            }
          }
        })

        //SET UPDATES
        if ("lightsOnTransition" in textureObject[material]) {
          var transition: any = {
            updateAt: textureObject[material].lightsOnTransition.updateAt,
            emissiveIntensity: textureObject[material].lightsOnTransition.emissiveIntensity,
            envMapIntensity: textureObject[material].lightsOnTransition.envMapIntensity,
            opacity: textureObject[material].lightsOnTransition.opacity,
            material: MaterialsToCreate[material]
          }
          if ("color" in textureObject[material].lightsOnTransition)
            transition.color = textureObject[material].lightsOnTransition.color
          if ("emissive" in textureObject[material].lightsOnTransition)
            transition.emissive = textureObject[material].lightsOnTransition.emissive
          MaterialsUpdatesLightOn[material] = transition
        }
        if ("lightsOffTransition" in textureObject[material]) {
          var transition: any = {
            updateAt: textureObject[material].lightsOffTransition.updateAt,
            emissiveIntensity: textureObject[material].lightsOffTransition.emissiveIntensity,
            envMapIntensity: textureObject[material].lightsOffTransition.envMapIntensity,
            opacity: textureObject[material].lightsOffTransition.opacity,
            material: MaterialsToCreate[material]
          }
          if ("color" in textureObject[material].lightsOffTransition)
            transition.color = textureObject[material].lightsOffTransition.color
          if ("emissive" in textureObject[material].lightsOffTransition)
            transition.emissive = textureObject[material].lightsOffTransition.emissive
          MaterialsUpdatesLightOff[material] = transition
        }
        
      }
    })

    MaterialsUpdates.lightsOnTransition = MaterialsUpdatesLightOn
    MaterialsUpdates.lightsOffTransition = MaterialsUpdatesLightOff

    this.materialsUpdatesRef = MaterialsUpdates;
    this.setState({
      materialToCreate: MaterialsToCreate
    }, () => {
      this.handleLoadModel()
    })
  }

  handleLoadModel = () => {

    var checkModel: any = modelsData()

    if(checkModel[this.props.currentCompleteCar]){
      this.setState({
        fovExterior: checkModel[this.props.currentCompleteCar].fovExtMobile,
        fovInterior: checkModel[this.props.currentCompleteCar].fovIntMobile
      }, () => {
        this.cameraRef.fov = this.state.fovExterior
        this.cameraRef.updateProjectionMatrix()
      })
      const gltfLoaderGLB = new GLTFLoader()
      const dracoLoader = new DRACOLoader()
      dracoLoader.setDecoderPath('draco/')
      gltfLoaderGLB.setDRACOLoader(dracoLoader)

      gltfLoaderGLB.load(checkModel[this.props.currentCompleteCar].model, (gltf: any) => {

        const animations = gltf.animations
        const model = gltf.scene
        model.name = 'car'
        this.modelRef = model

        this.animationRef = animations

        var interval : any;
        var tempCount = 1;
        interval = setInterval( () => {
          //console.log("checking" + this.pendingMaterials)
          if(tempCount === 0){

            model.traverse((element: any) => {
              if (element instanceof THREE.Mesh) {
                if (this.state.materialToCreate.hasOwnProperty(element.name.split('#')[1])) {
                  var texture = this.state.materialToCreate[element.name.split('#')[1]]
                  element.material = texture
                  this.rendererRef.renderLists.dispose()
                }
              }
            })
            this.sceneRef.add(model)
            this.rendererRef.renderLists.dispose()
  
            this.handleLoadDome()
            this.handleChangeColor()
            this.handleCreateBillboards()
            this.handleCreateBillboardsInterior()
            clearInterval(interval)
          }
        }, 100)
        setTimeout(() => {
          //in case it doesn't load on time
          tempCount = 0
        }, 2000);

      }, (xhr: any) => {
        if(xhr.total === 0 && this.props.isLocale === false){
          this.props.handleIsLocale()
        }
        else {
          this.props.handleGetLoadPercentage(((xhr.loaded / xhr.total) * 100)) 
        }
      })

    }
  }

  handleChangeColor = () => {
    if(this.props.currentCompleteCar !== ''){
      var colorData: any = colorsData()

      var color = colorData[this.props.currentCompleteCar][this.props.currentColorSelected].setUp
      const colorToAssing = new THREE.Color(color.color)
      const emissiveToAssing = new THREE.Color(color.emissive)
      var domeColor = "domeColor" in color ? new THREE.Color(color.domeColor) : colorToAssing
      var updateDomeColor: boolean = false
      updateDomeColor = this.props.currentSceneSelected && "default" in this.props.currentSceneSelected ? this.props.currentSceneSelected.default : true
  
      this.sceneRef.traverse((element: any) => {
        if (element.isMesh && element.material && (element.material.name === 'BodyPaint' || element.material.name === 'Car_Paint')) {
          /*element.material.emissive = new THREE.Color(color.emissive)
          element.material.emissiveIntensity = color.emissive
          element.material.metalness = color.metalness
          element.material.roughness = color.roughness
          element.material.clearcoat = color.clearCoatIntensity
          element.material.clearcoatRoughness = color.clearCoatRoughness
          element.material.reflectivity = color.reflectivity
          element.material.envMapIntensity = color.envMapIntensity*/

          gsap.to(element.material.color, {
            r: colorToAssing.r,
            g: colorToAssing.g,
            b: colorToAssing.b,
            duration: 1
          })
          gsap.to(element.material.emissive, {
            r: emissiveToAssing.r,
            g: emissiveToAssing.g,
            b: emissiveToAssing.b,
            duration: 1
          })
          gsap.to(element.material, {
            metalness: color.metalness,
            roughness: color.roughness,
            clearcoat: color.clearCoatIntensity,
            clearCoatRoughness: color.clearCoatRoughness,
            reflectivity: color.reflectivity,
            envMapIntensity: color.envMapIntensity,
            duration: 1
          })
        }
        if (updateDomeColor && element.name === 'Skydome') {

          gsap.to(element.material.color, {
            r: domeColor.r,
            g: domeColor.g,
            b: domeColor.b,
            duration: 1
          })
        }
      })

      this.rendererRef.renderLists.dispose()
    }
  }

  handleAllAnimations = () => {
    if (this.animationsConfigRef.activeAnimation === 'video' && this.animationsConfigRef.config.sync) {
      const cameraSync = new THREE.Vector3()
      this.animationsConfigRef.config.sync.getWorldScale(cameraSync)
      if(cameraSync.x > 1)
        return
    }

    const cameraPosition = new THREE.Vector3()
    const cameraTarget = new THREE.Vector3()

    this.animationsConfigRef.config.target.getWorldPosition(cameraTarget)
    this.controlsRef.target = cameraTarget

    this.animationsConfigRef.config.camera.getWorldPosition(cameraPosition)
    this.cameraRef.position.set(cameraPosition.x, cameraPosition.y, cameraPosition.z)

    if (this.animationsConfigRef.activeAnimation === 'video' && this.animationsConfigRef.config.fov) {
      const cameraFov = new THREE.Vector3()
      this.animationsConfigRef.config.fov.getWorldScale(cameraFov)
      this.cameraRef.fov = cameraFov.x //FOV definida en la animacion de video
      this.cameraRef.updateProjectionMatrix()
    }
    
  }

  handleMoveCameraToInterior = () => {

    if(this.props.isPlayingAnimation)
      return
    this.props.handleIsPlayingAnimation(true)
  
    this.props.handleShowInteriorLights(false)
    this.handleTurnOffLigths()

    this.rendererRef.renderLists.dispose()
    this.controlsRef.enableZoom = false
    this.controlsRef.enabled = false
    this.controlsRef.minDistance = 0.001
    this.controlsRef.maxPolarAngle = 140 * (Math.PI / 180)
    //if(this.props.isTouchScreen)
      this.controlsRef.rotateSpeed = -1

    //Animation 
    const mixer = new THREE.AnimationMixer(this.modelRef)
    mixer.stopAllAction()
    let clip = this.animationRef.find((object: any) => { return object.name === 'Ani_Ext-Int' });
    if (!clip)
      clip = this.animationRef[2]
    const action = new THREE.AnimationAction(mixer, clip)
    action.reset()
    action.play()
    action.clampWhenFinished = true
    action.setLoop(THREE.LoopOnce, 1)
    action.timeScale = 1
    action.time = 0
    action.weight = 1
    action.zeroSlopeAtEnd = true
    action.zeroSlopeAtStart = true
    action.startAt(0)
    mixer.update(0)//frame 0
    this.setState({ animationAction: action })

    const cameraPosition = new THREE.Vector3()
    const cameraTarget = new THREE.Vector3()

    const camera = this.sceneRef.getObjectByName('Cam_Ani_Ext-Int')
    camera.getWorldPosition(cameraPosition)
    const target = this.sceneRef.getObjectByName('Cam_Ani_Ext-IntTarget')
    target.getWorldPosition(cameraTarget)

    //middle
    this.animationsConfigRef.config = {
      'animationAction': action,
      'animationMixer': mixer,
      'camera': camera,
      'target': target,
    }

    //Camera rotation
    gsap.to(this.controlsRef.target, {
      x: cameraTarget.x,
      y: cameraTarget.y,
      z: cameraTarget.z,
      duration: 1.9,
      ease: 'linear'
    })

    //Camera position
    gsap.to(this.cameraRef.position, {
      x: cameraPosition.x,
      y: cameraPosition.y,
      z: cameraPosition.z,
      ease: 'linear',
      duration: 2,
      onComplete: () => {
        window.mixer = mixer
        this.animationsConfigRef.activeAnimation = 'interior'
      }
    })

    //Camera FOV
    setTimeout(() => {
      gsap.to(this.cameraRef, {
        fov: this.state.fovInterior,
        duration: 2,
        ease: 'linear',
        onUpdate: () => {
          this.cameraRef.updateProjectionMatrix()
        }
      })
    }, 1300)    

    //end of animation
    mixer.addEventListener('finished', (e) => {
      this.animationsConfigRef.activeAnimation = '';
      const cameraPosition = new THREE.Vector3();
      const cameraTarget = new THREE.Vector3();
      camera.getWorldPosition(cameraPosition)
      target.getWorldPosition(cameraTarget)
      const deltaTarget = new THREE.Vector3(cameraTarget.x-cameraPosition.x,cameraTarget.y-cameraPosition.y,cameraTarget.z-cameraPosition.z).multiplyScalar(0.01)
      const newTarget = cameraPosition.clone().add(deltaTarget)
      
      const fixPoint = this.modelRef.getObjectByName('Point_Conductor');
      if(fixPoint){
        const newPosition = new THREE.Vector3();
        fixPoint.getWorldPosition(newPosition);

        gsap.to(this.controlsRef.target, {
          x: newPosition.x,
          y: newPosition.y - 0.02,
          z: newPosition.z + 0.03,
          duration: 0.2,
          ease: 'power2.inOut',
        });
        gsap.to(this.cameraRef.position, {
          x: newPosition.x,
          y: newPosition.y,
          z: newPosition.z,
          duration: 0.2,
          ease: 'power2.inOut'
        });
      }else{
        this.cameraRef.position.set(cameraPosition.x, cameraPosition.y, cameraPosition.z);
        this.controlsRef.target = newTarget;
      }
      this.cameraRef.updateProjectionMatrix();

      this.state.animationAction.stop()
      this.props.handleIsPlayingAnimation(false)
      this.controlsRef.enabled = true
      this.controlsRef.maxDistance = 9
      this.controlsRef.minDistance = 0
      window.mixer = ''
    })

    document.addEventListener('wheel', this.handleMouseWheel, true)

  }

  handleMouseWheel = (e: any) => {
    const scaleFactor = e.deltaY > 0 ? 1 : -1
    if (scaleFactor === -1 && this.props.showInterior) {
      if (this.cameraRef.fov >= (this.state.fovExterior + 5)) {
        this.cameraRef.fov -= 5
        this.cameraRef.updateProjectionMatrix()
      }
    } else {
      if (this.cameraRef.fov < (this.state.fovInterior + 5) && this.props.showInterior) {
        this.cameraRef.fov += 5
        this.cameraRef.updateProjectionMatrix()
      }
    }
  }

  handleMoveCameraToExterior = () => {
    if(this.props.isPlayingAnimation)
      return
    this.props.handleIsPlayingAnimation(true)

    this.props.handleShowLigths(false)
    this.handleTurnOffLigths()

    this.rendererRef.renderLists.dispose()
    this.controlsRef.enabled = false
    this.controlsRef.maxPolarAngle = 90 * (Math.PI / 180)
    this.saopassRef.enabled = false
    this.controlsRef.rotateSpeed = 1

    //Animation
    const mixer = new THREE.AnimationMixer(this.modelRef)
    mixer.stopAllAction()
    let clip = this.animationRef.find((object: any) => { return object.name === 'Ani_Int-Ext' });
    if (!clip)
      clip = this.animationRef[1]
    const action = new THREE.AnimationAction(mixer, clip)
    action.reset()
    action.play()
    action.clampWhenFinished = true
    action.setLoop(THREE.LoopOnce, 1)
    action.timeScale = 1
    action.time = 0
    action.weight = 1
    action.zeroSlopeAtEnd = true
    action.zeroSlopeAtStart = true
    action.startAt(0)
    mixer.update(0)//frame 0
    this.setState({ moveInAnimation: action })

    const camera = this.sceneRef.getObjectByName('Cam_Ani_Ext-Int')
    const target = this.sceneRef.getObjectByName('Cam_Ani_Ext-IntTarget')
    
    //Start Optional
    if (this.props.currentSeatSelected !== 'FL') {
      const cameraPosition = new THREE.Vector3()
      const cameraTarget = new THREE.Vector3()
      camera.getWorldPosition(cameraPosition)
      target.getWorldPosition(cameraTarget)

      gsap.to(this.controlsRef.target, {
        x: cameraTarget.x,
        y: cameraTarget.y,
        z: cameraTarget.z,
        duration: 0.75,
        ease: 'linear',
      })
      gsap.to(this.cameraRef.position, {
        x: cameraPosition.x,
        y: cameraPosition.y,
        z: cameraPosition.z,
        duration: 0.75,
        ease: 'linear',
        onComplete: () => {
          this.animationsConfigRef.activeAnimation = 'exterior'
          window.mixer = mixer
          //Camera FOV
          setTimeout(() => {
            gsap.to(this.cameraRef, {
              fov: this.state.fovExterior,
              duration: 1.5,
              ease: 'linear',
              onUpdate: () => {
                this.cameraRef.updateProjectionMatrix()
              }
              ,
              onComplete: () => {
                this.controlsRef.enableZoom = true
                this.controlsRef.minDistance = 3
              }
            })
          }, 300)
        }
      })
    } else {
      this.animationsConfigRef.activeAnimation = 'exterior'
      window.mixer = mixer
      //Camera FOV
      setTimeout(() => {
        gsap.to(this.cameraRef, {
          fov: this.state.fovExterior,
          duration: 1.5,
          ease: 'linear',
          onUpdate: () => {
            this.cameraRef.updateProjectionMatrix()
          }
          ,
          onComplete: () => {
            this.controlsRef.enableZoom = true
            this.controlsRef.minDistance = 3
          }
        })
      }, 300)
    }

    //middle
    this.animationsConfigRef.config = {
      'animationAction': action,
      'animationMixer': mixer,
      'camera': camera,
      'target': target,
    }

    //finished
      mixer.addEventListener('finished', (e) => {
      this.animationsConfigRef.activeAnimation = ''
      this.state.animationAction.stop()

      gsap.to(this.cameraRef.position, {
        x: this.animationsConfigRef.startingCamera.x,
        y: this.animationsConfigRef.startingCamera.y,
        z: this.animationsConfigRef.startingCamera.z,
        duration: 2,
        ease: 'linear',
        onComplete: () => {
          this.props.handleIsPlayingAnimation(false)
          this.controlsRef.enabled = true
        }
      })
      gsap.to(this.controlsRef.target, {
        x: this.state.targetExterior.x,
        y: this.state.targetExterior.y,
        z: this.state.targetExterior.z,
        duration: 2,
        ease: 'linear'
      })
    })
  }

  handleMoveCameraStart = () => {
    this.props.handleIsPlayingAnimation(true)

    this.rendererRef.renderLists.dispose()
    const mixer = new THREE.AnimationMixer(this.modelRef)
    
    let clip = this.animationRef.find((object : any) => {return object.name ==='Ani_Intro'});
    if(!clip)
      clip = this.animationRef[3]
    const action = new THREE.AnimationAction(mixer, clip)
    action.play()
    action.clampWhenFinished = true
    action.setLoop(THREE.LoopOnce, 1);
    window.mixer = mixer
    this.setState({ animationAction: action, })

    const camera = this.sceneRef.getObjectByName('Cam_Intro')
    const target = this.sceneRef.getObjectByName('Cam_IntroTarget')

    this.animationsConfigRef.config = {
      'animationAction': action,
      'animationMixer': mixer,
      'camera': camera,
      'target': target,
    }
    this.animationsConfigRef.activeAnimation = 'start'

    mixer.addEventListener('finished', (e) => {
      this.handleAnimate()//force last position just in case
      this.animationsConfigRef.activeAnimation = ''
      const cameraPosition = new THREE.Vector3()
      camera.getWorldPosition(cameraPosition)
      this.animationsConfigRef.startingCamera = cameraPosition
      mixer.stopAllAction()
      mixer.uncacheClip(clip)
      mixer.setTime(0)
      this.state.animationAction.stop()
      this.controlsRef.enabled = true
      this.props.handleIsPlayingAnimation(false)
      
      const cameraTarget = new THREE.Vector3() //to avoid using the same reference in targetExterior
      cameraTarget.copy(this.controlsRef.target)
      this.setState({
        targetExterior: cameraTarget
      })
      setTimeout(() => {
        this.props.handleOpenDrag()
        this.controlsRef.addEventListener('change', () => {
          this.props.handleCloseDrag()
          this.controlsRef.removeEventListener('change', () => { })
        })
        mixer.removeEventListener('finished', () => { })
      }, 500);
    })
  }

  handleChangeSeat = () => {
    if(this.props.isPlayingAnimation)
      return
    this.props.handleIsPlayingAnimation(true)

    this.rendererRef.renderLists.dispose()
    this.controlsRef.enabled = false
    var point: any

    if (this.props.currentSeatSelected === 'FL')
      point = this.modelRef.getObjectByName('Point_Conductor')
    else if (this.props.currentSeatSelected === 'FR')
      point = this.modelRef.getObjectByName('Point_CoPiloto')
    else if (this.props.currentSeatSelected === 'BL')
      point = this.modelRef.getObjectByName('Point_PostConductor')
    else if (this.props.currentSeatSelected === 'BR')
      point = this.modelRef.getObjectByName('Point_PostCoPiloto')
    else if (this.props.currentSeatSelected === 'BL2')
      point = this.modelRef.getObjectByName('Point_Post2Conductor')
    else if (this.props.currentSeatSelected === 'BR2')
      point = this.modelRef.getObjectByName('Point_Post2CoPiloto')

    if(point === undefined){
      this.props.handleIsPlayingAnimation(false)
      this.controlsRef.enabled = true
      return;
    }

    gsap.to(this.controlsRef.target, {
      x: point.position.x,
      y: point.position.y - 0.02,
      z: point.position.z + 0.03,
      duration: 0.75,
      ease: 'linear',
    })

    gsap.to(this.cameraRef.position, {
      x: point.position.x,
      y: point.position.y,
      z: point.position.z,
      duration: 0.75,
      ease: 'linear',
      onComplete: () => {
        this.props.handleIsPlayingAnimation(false)
        this.controlsRef.enabled = true
      }
    })
  }

  handleCreateBillboards = () => {
    this.rendererRef.renderLists.dispose()
    var billboards: any = billboardsData()
    
    const billboardsGroup = new THREE.Group()

    const textureLoader = new THREE.TextureLoader();
    const texture = textureLoader.load('./bulletsTextures/Hotspot.jpg');
    const textureAlpha = textureLoader.load('./bulletsTextures/Hotspot.jpg');

    billboards[this.props.currentCompleteCar].exterior.map((billboards: any) => {
      const planeGeometry = new THREE.PlaneGeometry(0.15, 0.15);
      const planeMaterial = new THREE.MeshPhysicalMaterial({ 
        color: new THREE.Color(0xE7E7E7),
        emissive: new THREE.Color(0xFFFFFF),
        emissiveIntensity: 10,
        reflectivity: 1,
        roughness: 1,
        metalness: 1,
        map: texture, 
        emissiveMap: texture,
        alphaMap: texture,
        transparent: true, 
        depthWrite: false,
        depthTest: true,
        opacity: 0
      });
      const billboard = new THREE.Mesh(planeGeometry, planeMaterial);

      billboard.position.set(billboards.position.x, billboards.position.y, billboards.position.z);
      billboard.name = billboards.title + ' billboard exterior'

      gsap.to(billboard.scale, {
        duration: 1,
        repeat: -1,
        x: 1.2,
        y: 1.2,
        z: 1.2,
        yoyo: true,
        ease: 'power1.inOut'
      })

      billboardsGroup.add(billboard)
    })

    window.billboard = billboardsGroup

    this.sceneRef.add(billboardsGroup)
  }

  handleCreateBillboardsInterior = () => {
    this.rendererRef.renderLists.dispose()
    var billboards: any = billboardsData()
    
    const billboardsGroup = new THREE.Group()

    const textureLoader = new THREE.TextureLoader();
    const texture = textureLoader.load('./bulletsTextures/Hotspot.jpg');
    const textureAlpha = textureLoader.load('./bulletsTextures/Hotspot.jpg');

    billboards[this.props.currentCompleteCar].interior.map((billboards: any) => {
      const planeGeometry = new THREE.PlaneGeometry(0.05, 0.05);
      const planeMaterial = new THREE.MeshPhysicalMaterial({ 
        color: new THREE.Color(0xE7E7E7),
        emissive: new THREE.Color(0xFFFFFF),
        emissiveIntensity: 10,
        reflectivity: 1,
        roughness: 1,
        metalness: 1,
        map: texture, 
        emissiveMap: texture,
        alphaMap: texture,
        transparent: true, 
        depthWrite: true,
        opacity: 0
      });
      const billboard = new THREE.Mesh(planeGeometry, planeMaterial);

      billboard.position.set(billboards.position.x, billboards.position.y, billboards.position.z);
      billboard.name = billboards.title + ' billboard interior'

      gsap.to(billboard.scale, {
        duration: 1,
        repeat: -1,
        x: 1.2,
        y: 1.2,
        z: 1.2,
        yoyo: true,
        ease: 'power1.inOut'
      })

      billboardsGroup.add(billboard)
    })

    window.billboardInterior = billboardsGroup

    this.sceneRef.add(billboardsGroup)
  }

  handleShowBullets = () => {
    this.rendererRef.renderLists.dispose()
    if(this.props.showBullets){
      window.billboard.children.forEach((object: any) => {
        gsap.to(object.material, {
          opacity: 1,
          duration: 1,
          ease: 'linear'
        })
      })
    }
    else{
      window.billboard.children.forEach((object: any) => {
        gsap.to(object.material, {
          opacity: 0,
          duration: 1,
          ease: 'linear'
        })
      })
    }
  }

  handleShowBulletsInterior = () => {
    this.rendererRef.renderLists.dispose()
    if(this.props.showBulletsInterior){
      window.billboardInterior.children.forEach((object: any) => {
        gsap.to(object.material, {
          opacity: 1,
          duration: 1,
          ease: 'linear'
        })
      })
    }
    else{
      window.billboardInterior.children.forEach((object: any) => {
        gsap.to(object.material, {
          opacity: 0,
          duration: 1,
          ease: 'linear'
        })
      })
    }
  }

  handleChangeScene = () => {
    var dome = this.sceneRef && typeof this.sceneRef.getObjectByName === 'function' ? this.sceneRef.getObjectByName('dome') : null;
    if (!dome) {
      this.lightConfigRef = (this.inARMode === true || !("name" in this.props.currentSceneSelected)) ? this.defaultSceneAR : this.props.currentSceneSelected;
      return;
    }
    
    this.rendererRef.renderLists.dispose()
    this.lightConfigRef = (this.inARMode === true || !("name" in this.props.currentSceneSelected)) ? this.defaultSceneAR : this.props.currentSceneSelected
    if(!this.props.currentCompleteCar)
      return;
    
    new Promise((resolve, reject) => {
      
      this.rendererRef.renderLists.dispose()
      const image = new Image()
      image.src = this.lightConfigRef.map
      image.onload = (event: any) => {
        this.rendererRef.renderLists.dispose()
        const textureLoader = new THREE.TextureLoader();
        const textureDome = textureLoader.load(this.lightConfigRef.map);

        var colorData: any = colorsData()
        var color = colorData[this.props.currentCompleteCar][this.props.currentColorSelected].setUp
        var domeColor = new THREE.Color(0xFFFFFF)
        if(this.lightConfigRef.default === true)
          domeColor = "domeColor" in color ? new THREE.Color(color.domeColor) : ("color" in color ? new THREE.Color(color.color) : new THREE.Color(0xFFFFFF))
         
        const gltfLoader = new GLTFLoader()
        const dracoLoader = new DRACOLoader()
        dracoLoader.setDecoderPath('draco/')
        gltfLoader.setDRACOLoader(dracoLoader)
        
        gltfLoader.load('models/dome.glb', (gltf: any) => {
          this.rendererRef.renderLists.dispose()
          const model = gltf.scene
          model.name = 'dome'
          model.scale.set(1, 1, 1)
          this.domeRef = model
          this.domeRef.visible = this.inARMode !== true

          const material = model.getObjectByName('Skydome')
          dome.renderOrder = -1
          model.renderOrder = -1
          
          if (material) {
            material.material = new THREE.MeshBasicMaterial({
              map: textureDome,
              color: domeColor,
              opacity: 0,
              transparent: true
            })
          }

          this.sceneRef.add(model)

          gsap.to(material.material, {
            opacity: 1,
            duration: 1,
            onComplete: () => {
              material.material.transparent = false
              model.renderOrder = 0
              setTimeout(() => {
                window.billboard.visible = true
                window.billboardInterior.visible = true
              }, 1000)
            }
          })

          var domeMat = dome.getObjectByName('Skydome')
          domeMat.material.opacity = 1
          domeMat.material.transparent = true

          gsap.to(dome.material, {
            opacity: 0,
            duration: 1,
            onComplete: () => {
              this.sceneRef.remove(dome)
            }
          })

          if("ambientLight" in this.lightConfigRef){
            var nextColor = new THREE.Color(this.lightConfigRef.ambientLight.color)
            var nextIntensity = this.lightConfigRef.ambientLight.intensity
            gsap.to(this.ambientLightRef.color, {
              r: nextColor.r,
              g: nextColor.g,
              b: nextColor.b,
              duration: 1,
            })
            gsap.to(this.ambientLightRef, {
              intensity: nextIntensity,
              duration: 1,
            })
          }

          if(this.inARMode !== true){
            const loader = new THREE.CubeTextureLoader()
            loader.setPath(this.lightConfigRef.hdr).load(['px.png','nx.png','py.png','ny.png','pz.png','nz.png'],(texture: any) => {
              texture.flipY = false
              this.sceneRef.environment = texture
            })
          }
        })
      }
    })

    this.setState({
      currentDomeSelected: this.lightConfigRef.name
    })
  }

  handlePlayVideo = () => {

    if (this.animationsConfigRef.activeAnimation === 'video') {
      this.animationsConfigRef.activeAnimation = ''
      this.state.animationAction.stop()
      this.state.animationAction._mixer.stopAllAction()
      this.controlsRef.minDistance = 3

      gsap.to(this.cameraRef.position, {
        x: this.animationsConfigRef.startingCamera.x,
        y: this.animationsConfigRef.startingCamera.y,
        z: this.animationsConfigRef.startingCamera.z,
        duration: 2,
        ease: 'linear',
        onComplete: () => {
          this.controlsRef.enabled = true
          this.props.handleIsPlayingAnimation(false)
        }
      })
      gsap.to(this.controlsRef.target, {
        x: this.state.targetExterior.x,
        y: this.state.targetExterior.y,
        z: this.state.targetExterior.z,
        duration: 2,
        ease: 'linear'
      })
      gsap.to(this.cameraRef, {
        fov: this.state.fovExterior,
        duration: 2,
        ease: 'linear',
        onUpdate: () => {
          this.cameraRef.updateProjectionMatrix()
        }
      })
      return;
    }

    if (!this.props.showVideo)
      return
    if(this.props.isPlayingAnimation)
      return
    this.props.handleIsPlayingAnimation(true)

    this.props.handleShowLigths(false)
    this.handleTurnOffLigths()

    this.controlsRef.enabled = false
    this.controlsRef.minDistance = 0.001
    this.controlsRef.maxDistance = 9

    const mixer = new THREE.AnimationMixer(this.modelRef)
    mixer.stopAllAction()
    let clip = this.animationRef.find((object : any) => {return object.name ==='Cams_Anim'});
    if(!clip)
      clip = this.animationRef[0]
    const action = new THREE.AnimationAction(mixer, clip)
    action.reset()
    action.play()
    action.clampWhenFinished = true
    action.setLoop(THREE.LoopOnce, 1)
    action.timeScale = 1
    action.time = 0
    action.weight = 1
    action.zeroSlopeAtEnd = true
    action.zeroSlopeAtStart = true
    action.startAt(0)
    mixer.update(0)//frame 0
    this.setState({ animationAction: action })

    const cameraPosition = new THREE.Vector3()
    const cameraTarget = new THREE.Vector3()
    const cameraFov = new THREE.Vector3()

    const camera = this.sceneRef.getObjectByName('Cams_Anim')
    camera.getWorldPosition(cameraPosition)
    const target = this.sceneRef.getObjectByName('Cams_AnimTarget')
    target.getWorldPosition(cameraTarget)
    const fov = this.sceneRef.getObjectByName('Cams_AnimFOV')
    fov.getWorldScale(cameraFov)
    const sync = this.sceneRef.getObjectByName('Cams_AnimSYNC')

    //middle
    this.animationsConfigRef.config = {
      'animationAction': action,
      'animationMixer': mixer,
      'camera': camera,
      'target': target,
      'fov': fov,
      'sync': sync,
    }

    //Camera rotation
    gsap.to(this.controlsRef.target, {
      x: cameraTarget.x,
      y: cameraTarget.y,
      z: cameraTarget.z,
      duration: 1,
      ease: 'linear'
    })
    //Camera fov
    gsap.to(this.cameraRef, {
      fov: cameraFov.x,
      duration: 1,
      ease: 'linear',
      onUpdate: () => {
        this.cameraRef.updateProjectionMatrix()
      }
    })
    //Camera position
    gsap.to(this.cameraRef.position, {
      x: cameraPosition.x,
      y: cameraPosition.y,
      z: cameraPosition.z,
      ease: 'linear',
      duration: 1,
      onComplete: () => {
        this.animationsConfigRef.activeAnimation = 'video'
        window.mixer = mixer
        this.props.handleShowVideoText(true)
      }
    })

    mixer.addEventListener('finished', (e) => {
      this.animationsConfigRef.activeAnimation = ''
      this.controlsRef.minDistance = 3
      this.props.handleIsPlayingAnimation(false)
      this.props.handleShowVideo(false)
      this.props.handleShowVideoText(false)
      this.controlsRef.enabled = true
      /*** Esta parte debería estar dentro de la animación Cams_AnimFOV**/
      gsap.to(this.cameraRef, {
        fov: this.state.fovExterior,
        duration: 0.5,
        ease: 'linear',
        onUpdate: () => {
          this.cameraRef.updateProjectionMatrix()
        }
      })
      gsap.to(this.controlsRef.target, {
        x: this.state.targetExterior.x,
        y: this.state.targetExterior.y,
        z: this.state.targetExterior.z,
        duration: 0.5,
        ease: 'linear'
      })
      /****/
    })

  }

  render(): React.ReactNode {
      return(
        <canvas ref={this.canvasRef} className={this.props.openScene ? 'model-container fade-in':'model-container fade-out'}></canvas>
      )
  }
}

export default Scene